import { render } from "./AppBetaUserPopUp.vue?vue&type=template&id=685711c8&scoped=true&ts=true"
import script from "./AppBetaUserPopUp.vue?vue&type=script&lang=ts"
export * from "./AppBetaUserPopUp.vue?vue&type=script&lang=ts"

import "./AppBetaUserPopUp.vue?vue&type=style&index=0&id=685711c8&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685711c8"]])

export default __exports__